// // Location Map
// var ttmap;
// // The home marker
// var homeMarker;

// // clusterer
// var markerClusterer;

// // Message for the allow location message
// const mapLoadingScreenRequestText =
//   "Allow us to use your location and we'll find your nearest CHARLEYS.";
// // Message for the location loading screen
// const mapLoadingScreenText = "Finding your location...";
// // Message for not found
// const mapLoadingScreenNotFound = "Location not found. Try please again.";

// // Container for marker popups
// var infowindow;

// // Location isotope grid on locations page
// var $locationGrid;

// // Map location markers
// var markers = [];

// var markerIcon = {};
// var markerIconSelected = {};
// // determine if map is being loaded for the first time.
// var isFirstLoad = true;

// /*
// const mapStyle = [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}];
// */

// function isMobileOrTablet() {
//   var check = false;
//   // eslint-disable-next-line
//   (function (a) {
//     if (
//       /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
//         a
//       ) ||
//       /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
//         a.substr(0, 4)
//       )
//     )
//       check = true;
//   })(navigator.userAgent || navigator.vendor || window.opera);
//   return check;
// }

// window.isMobileOrTablet = window.isMobileOrTablet || isMobileOrTablet;

// // Elements that fire once dom is ready
// jQuery(document).ready(function ($) {
//   //Re-route from menu 
//   const storeLocationName = localStorage.getItem('ecw_customer_store_location_name');
//   const deliveryMode = localStorage.getItem('ecw_customer_deliverymode');
//   if (jQuery(".menu-root-page, body:not(.term-74) .menu-category-taxonomy-page").length) {
//     if(storeLocationName && deliveryMode) {
//       change_view("menu");
//     } else if (storeLocationName){
//       change_view("order");

//     } else {
//       $('.menu-root-page').removeClass('invisible');
//       $('.menu-category-taxonomy-page').removeClass('invisible');
//     }
//   }  else if ($('.menu-category-taxonomy-page')) {
//       $('.menu-category-taxonomy-page').removeClass('invisible');
    
//   }
//   // Initialize TomTom Map
//   if (!window.location.href.includes("/order/")) {
//     initMap(-98.5556199, 39.8097343);
//   }
//   // Set Default order URL
//   $("[data-order-link]").each(function () {
//     $(this).attr("href", ecwDefaultOrderURL);
//   });

//   if ($("#tt-map").length) {
//     const inputD = $("#location-search .search-field")[0];
//     const inputM = $("#location-search-m .search-field")[0];
//     const options = {
//       // componentRestrictions: { country: "us" },
//       // fields: ["address_components", "geometry", "icon", "name", "zipcode"],
//       strictBounds: false,
//       types: ["(regions)"],
//     };
//     const autocompleteD = new google.maps.places.Autocomplete(inputD, options);
//     autocompleteD.addListener("place_changed", function () {
//       const place = autocompleteD.getPlace();
//       if (place.geometry) {
//         ttmap.systemZoomChange = true;
//         getLocations(
//           place.geometry.location.lat(),
//           place.geometry.location.lng(),
//           "",
//           true
//         );
//       }
//     });

//     const autocompleteM = new google.maps.places.Autocomplete(inputM, options);
//     autocompleteM.addListener("place_changed", function () {
//       const place = autocompleteM.getPlace();
//       if (place.geometry) {
//         ttmap.systemZoomChange = true;
//         getLocations(
//           place.geometry.location.lat(),
//           place.geometry.location.lng(),
//           "",
//           true
//         );
//       }
//     });

//     // If a user ignores suggestions, this will catch and gecode the input
//     $("#location-search, #location-search-m").submit(function (e) {
//       e.preventDefault();
//       $(this).find(".search-field").blur();

//       var address = $(this).find(".search-field").val();
//       var geocoder = new google.maps.Geocoder();

//       geocoder.geocode(
//         {
//           address: address,
//         },
//         function (results, status) {
//           if (status == google.maps.GeocoderStatus.OK) {
//             ttmap.systemZoomChange = true;
//             getLocations(
//               results[0].geometry.location.lat(),
//               results[0].geometry.location.lng(),
//               "",
//               true
//             );
//           } else {
//             $(this).find(".search-field").val("");
//           }
//         }
//       );
//     });

//   }

//   if ($('#tt-map').length) {
//     //
//     //   var options = {
//     //     placeholder: 'Search City, State, or ZIP Code',
//     //     searchOptions: {
//     //       key: tomtom_api_key,
//     //       language: 'en-US',
//     //       limit: 15,
//     //       idxSet: 'Geo',
//     //       maxFuzzyLevel: 1,
//     //       center: {longitude: -98.5556199, latitude: 39.8097343}
//     //     },
//     //     autocompleteOptions: {
//     //       key: tomtom_api_key,
//     //       language: 'en-US',
//     //       resultSet: 'category'
//     //     },
//     //     filterSearchResults: function(result) {
//     //       console.log(result);
//     //       if(result.type == 'Geography') {
//     //         return true;
//     //       } else {
//     //         return false;
//     //       }
//     //     }
//     //   };
//     //
//     //   // if(true) {
//     //   //   options.searchOptions.countrySet = 'US';
//     //   // }
//     //
//     //   var ttSearchBoxM = new tt.plugins.SearchBox(tt.services, options);
//     //   var searchBoxHTMLM = ttSearchBoxM.getSearchBoxHTML();
//     //   $('.search-container.hide-for-large').append(searchBoxHTMLM);
//     //
//     //   var ttSearchBoxD = new tt.plugins.SearchBox(tt.services, options);
//     //   var searchBoxHTMLD = ttSearchBoxD.getSearchBoxHTML();
//     //   $('.search-container.show-for-large').append(searchBoxHTMLD);
//     //
//     //   ttSearchBoxM.on('tomtom.searchbox.resultselected', function(response) {
//     //     var lat = response.data.result.position.lat;
//     //     var lng = response.data.result.position.lng;
//     //     ttmap.systemZoomChange = true;
//     //     getLocations( lat, lng,  '', true );
//     //   });
//     //
//     //   ttSearchBoxD.on('tomtom.searchbox.resultselected', function(response) {
//     //     console.log(response);
//     //     var lat = response.data.result.position.lat;
//     //     var lng = response.data.result.position.lng;
//     //     ttmap.systemZoomChange = true;
//     //     getLocations( lat, lng,  '', true );
//     //   });
//     //
//     //   $('.tt-search-box-input').keyup(function(e) {
//     //     if(e.keyCode == 13) { // enter key
//     //       var $submittingform = $(this);
//     //       var address = $(this).val();
//     //
//     //       console.log(tt, address, tomtom_api_key);
//     //
//     //       tt.services.geocode({
//     //         key: tomtom_api_key,
//     //         query: address,
//     //         countrySet: 'US'
//     //       })
//     //       .then(function(response) {
//     //         console.log('success', response);
//     //         if (response.results.length > 0) {
//     //           ttmap.systemZoomChange = true;
//     //           var lat = response.results[0].position.lat;
//     //           var lng = response.results[0].position.lng;
//     //           getLocations( lat, lng,  '', true );
//     //         } else {
//     //           $submittingform.val('');
//     //         }
//     //       })
//     //       .catch(function(response) {
//     //         console.log('error', response);
//     //       });
//     //     }
//     //   });
//     //
//     ttmap.on('dragend', getMarkersInView);
//     ttmap.on('zoomend', getMarkersInView);
//   }

//   $("[data-tap-to-explore]").click(function () {
//     $(this).addClass("hide");
//     hideLoading();
//     showZoomPrompt();
//   });

//   // attempt to geolocate user
//   if (!localStorage.getItem("ecw_visitor_nearest_location_id")) {
//     geolocateUser();
//   } else {
//     if (ttmap) {
//       ttmap.systemZoomChange = true;
//     }
//     setLocation(true);
//   }
//   if (
//     $(".menu-grid").length &&
//     !localStorage.getItem("ecw_visitor_nearest_location_id")
//   ) {
//     // console.log('no location');

//     $(".menu-grid .food-item[data-is-default-cps], .menu-grid .food-item[data-is-read_only_menu]").each(function () {
//       $(this).removeClass("hide");
//     });
//     $(".menu-grid .food-item:not([data-is-default-cps], .menu-grid .food-item[data-is-read_only_menu])").each(function () {
//       $(this).addClass("hide");
//     }); 
//   } else if ($(".menu-grid").length &&
//   localStorage.getItem("ecw_visitor_nearest_location_id")) {
//     // console.log('location');
//     $(".menu-grid .food-item[data-is-default-cps], .menu-grid .food-item[data-is-read_only_menu]").each(function () {
//       $(this).removeClass("hide");
//     });
//   }
// }); // end jQuery ready

// // Fires to prep the TOMTOM map
// function initMap(longitude, latitude) {
//   // console.log("initMap");
//   var $ = jQuery;

//   if ($("#tt-map").length) {
//     tt.setProductInfo("East Coast Wings Location Map", "2.0.0"); 
//     ttmap = tt.map({
//       key: tomtom_api_key,
//       container: "tt-map",
//       // style: 'tomtom://vector/1/basic-main',
//       // dragPan: !isMobileOrTablet(),
//       // Center on the USA
//       center: [-98.5556199, 39.8097343],
//       zoom: 15,
//       language: "en-US",
//     });
//     ttmap.addControl(new tt.FullscreenControl());
//     ttmap.addControl(new tt.NavigationControl());
//     // console.log('adsgdsagasg');

//   } // end if
// } // end initMap

// // Shows loading cover elements
// function showLoading() {
//   // console.log("showLoading");
//   var $ = jQuery;

//   $("[data-tap-to-explore]").addClass("hide");
//   $("[data-loading-icon]").removeClass("hide");
//   $("[data-map-cover]").removeClass("hide");
//   $("[data-search-column-cover]").removeClass("hide");
// } // end showLoading

// // Hides loading cover elements
// function hideLoading() {
//   // console.log("hideLoading");
//   var $ = jQuery;
//   $("[data-map-cover]").addClass("hide");
//   $("[data-search-column-cover]").addClass("hide");
// } // end hideLoading

// // Shows the Zoom prompt covering the map
// function showZoomPrompt() {
//   // console.log("showZoomPrompt");
//   var $ = jQuery;
//   $("[data-map-zoom-prompt]").removeClass("hide");
// } // end showZoomPrompt

// // Hides the zoom in prompt for map
// function hideZoomPrompt() {
//   // console.log("hideZoomPrompt");
//   var $ = jQuery;
//   $("[data-map-zoom-prompt]").addClass("hide");
// } // end hideZoomPrompt

// // Shows the prompt for no markers within range
// function showEmptyPrompt() {
//   // console.log("showEmptyPrompt");
//   var $ = jQuery;
//   $("[data-map-empty-prompt]").removeClass("hide");
// } // end showEmptyPrompt

// // Hides the prompt for no markers within range
// function hideEmptyPrompt() {
//   // console.log("hideEmptyPrompt");
//   var $ = jQuery;
//   $("[data-map-empty-prompt]").addClass("hide");
// } // end showEmptyPrompt

// // Gets the markers within map view - plus a bit outside view.
// function getMarkersInView() {
//   // console.log("getMarkersInView");
//   if (!ttmap.systemZoomChange) {
//     if (ttmap.getZoom() >= 7) {
//       var bounds = ttmap.getBounds();
//       var mCenter = bounds.getCenter();
//       var neCorner = bounds.getNorthEast();

//       var lat1 = mCenter.lat,
//         lat2 = neCorner.lat,
//         lon1 = mCenter.lng,
//         lon2 = neCorner.lng;

//       const R = 6371e3; // metres
//       const φ1 = (lat1 * Math.PI) / 180; // φ, λ in radians
//       const φ2 = (lat2 * Math.PI) / 180;
//       const Δφ = ((lat2 - lat1) * Math.PI) / 180;
//       const Δλ = ((lon2 - lon1) * Math.PI) / 180;

//       const a =
//         Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
//         Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
//       const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

//       const distance = R * c * 0.000621371192; // convert meters to miles

//       // console.log(distance);

//       getLocations(mCenter.lat, mCenter.lng, distance);
//       hideZoomPrompt();
//     } else {
//       clearAllMarkers();
//       showZoomPrompt();
//       hideEmptyPrompt();
//     }
//   } else {
//     ttmap.systemZoomChange = false;
//   }
// } // end getMarkersInView
// // Gets locations from center to distance.
// function getLocations(lat, lng, dist, setBounds = false) {
//   // console.log("getLocations", lat, lng, dist);
//   var $ = jQuery;

//   showLoading();

//   $.ajax({
//     type: "POST",
//     url: ajax_url,
//     data: {
//       // action: "get_nearby_locations",
//       action: "get_blended_nearby_locations",
//       lat: lat,
//       long: lng,
//       distance: dist,
//     },
//     success: function (response) {
//       // console.log(response);
//       var result = JSON.parse(response);
//       // console.log("a", result);
//       if (result.status == "success") {
//         hideEmptyPrompt();
//         setLocationGrid(result.data.restaurants);
//         if (setBounds) {
//           fitToMarkerBounds(ttmap);
//           $(".results-container").animate(
//             {
//               scrollTop: 0,
//             },
//             500
//           );
//         }
//       } else {
//         showEmptyPrompt();
//         clearAllMarkers();
//       }
//       hideLoading();
//     },
//     error: function () { },
//   });
// } // end getLocations

// // Sets the grid list of locations
// function setLocationGrid(data) {
//   // console.log("setLocationGrid");
//   var $ = jQuery;

//   clearAllMarkers();

//   if (data && data.length > 0) {
//     $("[data-search-cover]").addClass("hide");
//     $("[data-nearby-heading]").removeClass("hide");
//     hideZoomPrompt();

//     // console.log("Data", data);

//     for (var i = 0; i < data.length; i++) {
//       getLocationInfo();

//       function getLocationInfo() {
//         var locationGroups = data[i]['location_groups'];
//         var locationItemClone = $('#location-grid [data-location-template]').clone();

//         locationItemClone.attr('id', 'location-' + data[i]['id']);
//         locationItemClone.attr('data-store-number', data[i]['extref']);

//         locationItemClone.find('#location-select-').attr('value', 'location-select-' + data[i]['id']);
//         locationItemClone.find('#location-select-').attr('id', 'location-select-' + data[i]['id']);
//         locationItemClone.find('label').attr('for', 'location-select-' + data[i]['id']);

//         locationItemClone.find('label').attr('data-location-id', data[i]['id']);
//         locationItemClone.find('label').attr('data-title', data[i]['name']);

//         locationItemClone.find('label').attr('data-permalink', data[i]['permalink']);
//         locationItemClone.find('label').attr('data-store-id', data[i]['extref']);
//         locationItemClone.find('label').attr('data-location-groups', locationGroups);

//         if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStores.includes(locationItemClone.attr('data-store-number')))) {
//           locationItemClone.find('label').attr('data-order-url', '/order/?store=' + data[i]['slug']);
//         } else {
//           locationItemClone.find('label').attr('data-order-url', data[i]['url']);
//         }

//         locationItemClone.find('.location-title strong').html(data[i]['name']);

//         if (locationItemClone.find('.set-location-button').length) {

//           locationItemClone.find('.set-location-button').attr('data-location-id', data[i]['id']);
//           locationItemClone.find('.set-location-button').attr('data-title', data[i]['name']);
//           locationItemClone.find('.set-location-button').attr('data-order-url', data[i]['url']);
//           locationItemClone.find('.set-location-button').attr('data-permalink', data[i]['permalink']);
//           locationItemClone.find('.set-location-button').attr('data-store-id', data[i]['extref']);
//           locationItemClone.find('.set-location-button').attr('data-location-groups', locationGroups);

//           locationItemClone.find('.set-location-button').attr('data-show-on', 'large');
//           locationItemClone.find('.set-location-button').attr('title', 'Make My Store');
//           locationItemClone.find('.set-location-button').attr('aria-label', 'Make My Store');

//           if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStores.includes(locationItemClone.attr('data-store-number')))) {
//             locationItemClone.find('.set-location-button').attr('data-order-url', '/order/?store=' + data[i]['slug']);
//           } else {
//             locationItemClone.find('.set-location-button').attr('data-order-url', data[i]['url']);
//           }

//           new Foundation.Tooltip(locationItemClone.find('.set-location-button'), {});

//           locationItemClone.find('.set-location-button').click(function () {
//             localStorage.setItem('ecw_location_page_location_id', $(this).attr('data-location-id'));
//             setAsStore($(this).attr('data-location-id'), $(this).attr('data-title'), $(this).attr('data-order-url'), $(this).attr('data-permalink'), $(this).attr('data-store-id'), $(this).attr('data-location-groups'), false);
//           });
//         }

//         if (localStorage.getItem('ecw_visitor_nearest_location_id') == data[i]['id']) {
//           locationItemClone.find('.set-location-button').addClass('current-location');
//         }

//         locationItemClone.find('.location-address strong').html(data[i]['streetaddress'] + '<br class="hide-for-large" /> ' + data[i]['city'] + ', ' + data[i]['state'] + ' ' + data[i]['zip']);

//         if (data[i]['telephone']) {
//           locationItemClone.find('.location-phone a').attr('href', 'tel:' + data[i]['telephone']);
//           locationItemClone.find('.location-phone a').text(data[i]['telephone']);
//         } else {
//           locationItemClone.find('.location-phone a').remove();
//         }

//         locationItemClone.find('.learn-more').attr('href', data[i]['permalink']);

//         // Is a non OLO Store
//         if (data[i]['id'].toString().includes('wp_')) {
//           locationItemClone.find('.order-now-details').attr('href', data[i]['url']);
//           locationItemClone.find('.order-now-details').addClass('hide');
//           // Check if opted-in to new experience
//         } else if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStores.includes(locationItemClone.attr('data-store-number')))) {
//           locationItemClone.find('.order-now-details').attr('href', '/order/?store=' + data[i]['slug']);
//           locationItemClone.find('.order-now-details').attr('data-customer-store-location-id', data[i]['id']);
//           locationItemClone.find('.order-now-details').removeClass('hide');
//           // If not opted-in, set link dependent on availability of access token and URL
//         } else {
//           if (data[i]['url'].length) {
//             if (localStorage.getItem('ecw_access_token')) {
//               locationItemClone.find('.order-now-details').attr('href', 'https://order.ecw.com/login/punchh/' + localStorage.getItem('ecw_access_token'));
//               locationItemClone.find('.order-now-details').removeClass('hide');
//             } else {
//               locationItemClone.find('.order-now-details').attr('href', data[i]['url']);
//               locationItemClone.find('.order-now-details').removeClass('hide');
//             }
//           }
//         }

        

//         locationItemClone.find('.location-distance [data-miles-away]').text(parseFloat(data[i]['distance']).toFixed(1));
//         locationItemClone.find('.location-distance').removeClass('invisible');

//         locationItemClone.removeAttr('data-location-template');
//         locationItemClone.removeClass('hide');



//         $('#location-grid').append(locationItemClone);

//         var popupHTML = '<div class="title">' +
//           '<strong>' + data[i]['name'] + '</strong>' +
//           '</div>' +
//           '<div class="address">' + data[i]['streetaddress'] + '<br /> ' + data[i]['city'] + ', ' + data[i]['state'] + ' ' + data[i]['zip'] + '</div>' +
//           '<div class="phone"><a href="tel:' + data[i]['telephone'] + '" class="underline">' + data[i]['telephone'] + '</a></div>';

//         popupHTML += '<div class="info"><a href="' + data[i]['permalink'] + '" class="button info-button" tabindex="0">Store Info</a></div>'; 

//         // Format is lng , lat ... WHICH IS BACKWARDS TOMTOM
//         markers.push(createMarker([parseFloat(data[i]['longitude']), parseFloat(data[i]['latitude'])], popupHTML, ttmap));
//       }

//     }


//   }



//   $('#location-grid .location-item:not(.hide) a[data-customer-store-location-id]').click(function (e) {
//     e.preventDefault();
//     localStorage.setItem('ecw_location_page_location_id', $(this).attr('data-customer-store-location-id'));
//     window.location.href = $(this).attr('href');
//   });

//   $('#location-grid input[type="radio"] + label').click(function () {
//     var markerIndex = $(this).parent().index() - 1; // account for template
//     //
//     // var marker = new google.maps.Marker({});
//     // new google.maps.event.trigger(markers[markerIndex], 'click');

//     // Close any open popups
//     for (var i = 0; i < markers.length; i++) {
//       if (markers[i].getPopup().isOpen()) {
//         markers[i].togglePopup();
//       }
//     }
//     // Open popup
//     markers[markerIndex].togglePopup();

//     setAsStore($(this).attr('data-location-id'), $(this).attr('data-title'), $(this).attr('data-order-url'), $(this).attr('data-permalink'), $(this).attr('data-store-id'), $(this).attr('data-location-groups'), false);

//     // Zoom in to location
//     // ttmap.setCenter(markers[markerIndex].position);
//     // ttmap.setZoom(11);
//   });

//   if (localStorage.getItem('ecw_visitor_nearest_location_id') && isFirstLoad) {
//     var pid = localStorage.getItem('ecw_visitor_nearest_location_id');
//     if ($('#location-' + pid).length) {
//       var markerIndex = $('#location-' + pid).index() - 1; // account for template
//       // markers[markerIndex].click();
//       // var marker = new google.maps.Marker({});
//       // new google.maps.event.trigger(markers[markerIndex], 'click');

//       // Close any open popups
//       for (var i = 0; i < markers.length; i++) {
//         if (markers[i].getPopup().isOpen()) {
//           markers[i].togglePopup();
//         }
//       }
//       // Open popup
//       markers[markerIndex].togglePopup();

//       $('#location-select-' + pid).prop('checked', true);
//     }
//     isFirstLoad = false;
//   }

//   // setClusters();
// } // end setLocationGrid

// // Creates a marker on the map
// function createMarker(position, popupHTML, ttmapObj) {
//   // console.log('add marker', popupHTML, position);
//   var markerElement = document.createElement("div");
//   markerElement.className = "marker";

//   var markerContentElement = document.createElement("div");
//   markerContentElement.className = "marker-content";

//   markerElement.appendChild(markerContentElement);

//   // console.log('Create Marker', position);

//   var markerHeight = 50,
//     markerRadius = 25,
//     linearOffset = 0;

//   var popupOffsets = {
//     top: [markerHeight / 2, 0],
//     "top-left": [0, 0],
//     "top-right": [0, 0],
//     bottom: [0, -markerHeight],
//     "bottom-left": [
//       linearOffset,
//       (markerHeight - markerRadius + linearOffset) * -1,
//     ],
//     "bottom-right": [
//       -linearOffset,
//       (markerHeight - markerRadius + linearOffset) * -1,
//     ],
//     left: [markerRadius, (markerHeight - markerRadius) * -1],
//     right: [-markerRadius, (markerHeight - markerRadius) * -1],
//   };

//   var popup = new tt.Popup({ offset: popupOffsets }).setHTML(popupHTML);

//   // console.log(position, popup, ttmapObj);
//   // add marker to map
//   return new tt.Marker({ element: markerElement, anchor: "bottom" })
//     .setLngLat(position)
//     .setPopup(popup)
//     .addTo(ttmapObj);
// }

// // Clears all markers on the map
// function clearAllMarkers() {
//   // console.log("clearAllMarkers");
//   var $ = jQuery;
//   // Set location grid heading
//   $("[data-search-cover]").removeClass("hide");
//   $("[data-nearby-heading]").addClass("hide");
//   // clear out location items
//   $("#location-grid .location-item:not(.hide)").each(function () {
//     $(this).remove();
//   });
//   // Clear all map markers
//   for (var m = 0; m < markers.length; m++) {
//     markers[m].remove();
//   }
//   markers = [];
// } // end clearAllMarkers

// // Fits bounds to markers
// function fitToMarkerBounds(ttmapObj) {
//   // console.log("fitToMarkerBounds");

//   if (markers.length) {
//     var bbox = [
//       [0, 0],
//       [0, 0],
//     ];
//     var lats = [];
//     var lngs = [];

//     for (var i = 0; i < markers.length; i++) {
//       var lnglat = markers[i].getLngLat();
//       lats.push(lnglat.lng);
//       lngs.push(lnglat.lat);
//     }

//     var minlat = Math.min.apply(null, lats),
//       maxlat = Math.max.apply(null, lats);
//     var minlng = Math.min.apply(null, lngs),
//       maxlng = Math.max.apply(null, lngs);

//     bbox = [
//       [minlat, minlng],
//       [maxlat, maxlng],
//     ];

//     ttmapObj.fitBounds(bbox, {
//       padding: { top: 75, bottom: 75, left: 75, right: 75 },
//       maxZoom: 12,
//     });
//   }
// } // end fitToMarkerBounds

// // Geolocates the user if permission is given
// function geolocateUser() {
//   // console.log("geolocateUser");
//   var $ = jQuery;
//   // console.log('Get Location');

//   setFindingLocation();

//   navigator.geolocation.getCurrentPosition(
//     function (position) {

//       var latitude = position.coords.latitude;
//       var longitude = position.coords.longitude;
//       // console.log('latitude', latitude); 
//       // console.log('longitude', longitude);

//       $.ajax({
//         type: "POST",
//         url: ajax_url,
//         data: {
//           // action: "get_nearby_locations",
//           action: "get_blended_nearby_locations",
//           lat: latitude,
//           long: longitude,
//           distance: "",
//         },
//         success: function (response) {
//           var data = JSON.parse(response);
//           // console.log("data", data);

//           if (data.data.restaurants.length > 0) {

//             // setAsStore(data.data[0]['ID'], data.data[0]['title'], data.data[0]['order_url'], data.data[0]['location_details']);
//             setAsStore(data.data.restaurants[0]['id']);
//             // set 3 other nearby stores--per request of Drew

//             const stores = data.data.restaurants;

//             for (let i = 1; i <= 3; i++) {
//               if (stores.length > i) {
//                 localStorage.setItem(`nearByStore${i}`, stores[i]['id']);
//               }
//             }
//           } else {

//             unsetFindingLocation();
//           }
//         },
//         error: function () {

//         },
//       });
//     },
//     function (error) {
//       if (!localStorage.getItem("ecw_visitor_nearest_location_id")) {
//         unsetFindingLocation();
//         // setLoadingCoverScreen(mapLoadingScreenRequestText, true);
//       }
//       // console.log('denied: ', error);
//       // $('#wf-store-locator-get-location').prop('disabled', true);
//       // setAlertMessage('Error: ' + error.message);
//     },
//     function (options) {
//       // console.log('options: ', options);
//     }
//   );
// } // end geolocateUser
// function highlightMarker(order_markers) {
//   const $ = jQuery;

//   showLoading();

//     // const nearestLocationId = localStorage.getItem('ecw_visitor_nearest_location_id');
//     // const $nearestItem = $(`#order-location-list [data-location-id="${nearestLocationId}"]`);
//     // const nearestItemTitle = $nearestItem.find('h5 strong').text().trim();

//     // const markerToHighlight = order_markers.find(marker => {
//     //   return marker.getTitle().trim().toLowerCase() === nearestItemTitle.toLowerCase();
//     // });
  
//     // if (markerToHighlight) {
//     //   google.maps.event.trigger(markerToHighlight, 'click');
//     // } 
  
//   // if ($('#google-map').length) {
//   //   var map = new google.maps.Map(document.getElementById('google-map'), {
//   //     center: centerCoords,
//   //     zoom: 6,
//   //     mapTypeControl: false,
//   //     fullscreenControl: false,
//   //     styles: mapStyle
//   //   });
  
//   //   const markerIconSelected = {
//   //     url: 'https://feasab-test-east-coast-wings-new.pantheonsite.io/wp-content/uploads/2025/07/icon-map-marker-selected.svg',
//   //     scaledSize: new google.maps.Size(70, 70)
//   //   };
  
//   //   const markerIcon = {
//   //     url: 'https://feasab-test-east-coast-wings-new.pantheonsite.io/wp-content/uploads/2025/07/icon-map-marker.svg',
//   //     scaledSize: new google.maps.Size(50, 50)
//   //   };
  
//   //   const nearestLocationId = localStorage.getItem('ecw_visitor_nearest_location_id');
//   //   const $nearestItem = $(`#order-location-list [data-location-id="${nearestLocationId}"]`);
//   //   const nearestItemTitle = $nearestItem.find('h5 strong').text().trim();
  
  
//   //   for (let i = 0; i < order_markers.length; i++) {
//   //     order_markers[i].setMap(map); // Re-attach to the new map
//   //     order_markers[i].setIcon(markerIcon);

//   //   }
  
//   //   const markerToHighlight = order_markers.find(marker => {
//   //     return marker.getTitle().trim().toLowerCase() === nearestItemTitle.toLowerCase();
//   //   });
  
//   //   if (markerToHighlight) {
//   //     markerToHighlight.setIcon(markerIconSelected);
//   //     // console.log(`✅ Highlighted marker titled: ${markerToHighlight.getTitle()}`);
//   //   } 
//   // }
//   hideLoading();

// }





// // Sets selectd store
function setAsStore(
  locationID,
  title = "",
  order_url = "",
  permalink = "", 
  store_num = "",
  location_groups = "",
  set_store_location = true, 
  order_markers, 
  update_map_marker
) {
  
  var $ = jQuery;
  unsetLocationLocalStorage();
  console.log('user changed thier selected location');

  // Unset all location buttons
  $(".set-location-button").each(function () {
    $(this).removeClass("current-location");
    $(this).find('.subheading').text("MAKE THIS YOUR LOCATION");
  });

  localStorage.setItem("ecw_visitor_nearest_location_id", locationID);
  if (order_markers && update_map_marker) {
    highlightMarker(order_markers);

  }
  if (
    !title.length ||
    !order_url.length ||
    !permalink.length ||
    !store_num.length ||
    !location_groups.length
  ) {

    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "get_location",
        location_id: locationID,
        referer: window.location.href

      },
      success: function (response) {
        console.log('get_location', response); 
        var result = JSON.parse(response);

        var location_groups = '';

        if (result.data) {
          localStorage.setItem('ecw_visitor_nearest_location', result.data['name']);
          localStorage.setItem('ecw_visitor_order_url', result.data['url']);
          localStorage.setItem('ecw_visitor_location_details', result.data['permalink']);
          localStorage.setItem('ecw_visitor_location_store', result.data['extref']);
          localStorage.setItem('ecw_visitor_location_groups', result.data['location_groups']);
          if (set_store_location) {
            localStorage.setItem('ecw_customer_store_location_id', result.data['id']);
          }

          if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStores.includes(result.data['extref']))) {
            localStorage.setItem('ecw_visitor_order_url', '/order/?store=' + result.data['slug']);
            hideFakeMenuIfAddedLocation();
          } else {
            if (localStorage.getItem('ecw_access_token')) {
              localStorage.setItem('ecw_visitor_order_url', 'https://order.ecw.com/login/punchh/' + localStorage.getItem('ecw_access_token'));
            }
          }
          //
          // let visitorOrderUrl = result.data['url'];
          // hideFakeMenuIfAddedLocation(visitorOrderUrl);
          //
          // setLocation();
          // ecw_hide_loading();
        }
      },
      error: function () { },
    });
  } else {
    console.log('get_location!'); 

    localStorage.setItem("ecw_visitor_nearest_location", title);
    localStorage.setItem("ecw_visitor_order_url", order_url);
    localStorage.setItem("ecw_visitor_location_details", permalink);
    localStorage.setItem("ecw_visitor_location_store", store_num);
    localStorage.setItem("ecw_visitor_location_groups", location_groups);
    if (set_store_location) {
      localStorage.setItem('ecw_customer_store_location_id', locationID);
    }
    setLocation();
  }

} // end setAsStore

// // Unsets location Local Storage
// function unsetLocationLS() {
//   // console.log("unsetLocationLS");
//   localStorage.removeItem("ecw_visitor_nearest_location_id");
//   localStorage.removeItem("ecw_visitor_nearest_location");
//   localStorage.removeItem("ecw_visitor_order_url");
//   localStorage.removeItem("ecw_visitor_delivery_url");
//   localStorage.removeItem("ecw_visitor_delivery_off");
//   localStorage.removeItem("ecw_visitor_location_details");
//   localStorage.removeItem("ecw_visitor_location_store");
//   localStorage.removeItem("ecw_visitor_location_groups");
//   localStorage.removeItem('nearByStore1');
//   localStorage.removeItem('nearByStore2');
//   localStorage.removeItem('nearByStore3');
// }

// // Sets location
// function setLocation(reload = false) {
//   // console.log("setLocation");
//   var $ = jQuery;

//   // Set Location Button to reflect current store.
//   $("[data-find-location-button]").each(function () {
//     $(this).find("[data-find-location]").addClass("hide");
//     $(this).find("[data-find-location-show]").addClass("hide");
//     $(this).find("[data-find-location-finding]").removeClass("hide");

//     $(this)
//       .find("[data-find-location-name] strong")
//       .text(
//         decodeEntities(
//           localStorage.getItem("ecw_visitor_nearest_location")
//         )
//       );
//     $(this).find("[data-find-location-finding]").addClass("hide");
//     $(this).find("[data-find-location-show]").removeClass("hide");

//     $(this).removeClass("hide");
//   });

//   // Set location buttons
//   $(
//     '.set-location-button[data-location-id="' +
//     localStorage.getItem("ecw_visitor_nearest_location_id") +
//     '"]'
//   ).each(function () {
//     $(this).addClass("current-location");
//   });

//   // Set Order Buttons
//   if (localStorage.getItem("ecw_visitor_order_url")) {
//     $("[data-order-link]").each(function () {
//       $(this).attr("href", localStorage.getItem("ecw_visitor_order_url"));
//     });
//   }

//   // Set map
//   if ($("#tt-map").length && reload) {
//     showLoading();
//     $.ajax({
//       type: "POST",
//       url: ajax_url,
//       data: {
//         action: "get_location",
//         location_id: localStorage.getItem(
//           "ecw_visitor_nearest_location_id"
//         ),
//       },
//       success: function (response) {
//         // console.log(response);
//         var data = JSON.parse(response);
//         if (data.data) {
//           getLocations(data.data["latitude"], data.data["longitude"], "", true);
//         }
//       },
//       error: function () { },
//     });
//   }

//   showFoodMenu();
// }

// // Sets finding location message elements
// function setFindingLocation() {
//   // console.log("setFindingLocation");
//   var $ = jQuery;

//   // $("[data-please-set-location]").addClass("hide");
//   // $("[data-finding-your-location]").removeClass("hide");

//   $("[data-find-location-button]").each(function () {
//     $(this).find("[data-find-location]").addClass("hide");
//     $(this).find("[data-find-location-show]").addClass("hide");
//     $(this).find("[data-find-location-finding]").removeClass("hide");
//     $(this).removeClass("hide");
//   });

//   $("[data-show-for-no-location]").each(function () {
//     $(this).removeClass("hide");
//   });
// } // end setFindingLocation

// function unsetFindingLocation() {
//   // console.log("unsetFindingLocation");

  
//   // console.log('unset finding location');
//   var $ = jQuery;
//   $("[data-find-location-button]").each(function () {
//     $(this).find("[data-find-location-show]").addClass("hide");
//     $(this).find("[data-find-location-finding]").addClass("hide");
//     $(this).find("[data-find-location]").removeClass("hide");
//     $(this).removeClass("hide");
//   });

//   if (!localStorage.getItem("ecw_visitor_location_store") || !localStorage.getItem("ecw_customer_store_location_name")) {
//     // Hide all location dependent elements
//     $('[data-show-for-stores*="yes"]').each(function() {
//       $(this).removeClass('hide');
//     });
//     // console.log('no location');
//     // $("[data-please-set-location]").removeClass("hide");
//     // $("[data-finding-your-location]").addClass("hide");
//   }
// } // end unsetFindingLocation

// // Shows food menu items depending on location .
// function showFoodMenu() {
//   // console.log("showFoodMenu");

//   var $ = jQuery;

//   var currentStoreNumber = localStorage.getItem(
//     "ecw_visitor_location_store"
//   );
//   var currentLocGroups = localStorage.getItem(
//     "ecw_visitor_location_groups"
//   );

//   // console.log(currentStoreNumber, currentLocGroups);

//   // patch for previous bug where store # and groups were blanks
//   // if (!currentStoreNumber || !currentLocGroups) {
//   if (!currentStoreNumber) {
//     setAsStore(localStorage.getItem("ecw_visitor_nearest_location_id"));

//     currentStoreNumber = localStorage.getItem(
//       "ecw_visitor_location_store"
//     );
//     currentLocGroups = localStorage.getItem("ecw_visitor_location_groups");
//   }

//   if (currentLocGroups) {
//     currentLocGroups = currentLocGroups.split(",");
//   }
//   // console.log(currentStoreNumber, currentLocGroups);

//   // $("[data-please-set-location]").addClass("hide");
//   // $("[data-finding-your-location]").addClass("hide");

//   // // Display elements related to stores
//   $('[data-show-for-stores]').each(function () {
//     if ($(this).attr('data-show-for-stores').includes('yes')) {
//       $(this).removeClass('hide');
//     } else {
//       $(this).addClass('hide');
//     }
//   });

//   // Display elements related to store category
//   $("[data-show-for-category]").each(function () {
//     if (currentLocGroups) {
//       var showcats = $(this).attr("data-show-for-category").split(",");
//       if (showcats.length !== 0) {
//         var showElement = false;

//         // console.log(currentLocGroups, showcats);

//         if (currentLocGroups && showcats.length) {
//           for (var s = 0; s < showcats.length; s++) {
//             for (var ss = 0; ss < currentLocGroups.length; ss++) {
//               if (showcats[s] == currentLocGroups[ss]) {
//                 showElement = true;
//                 break;
//               }
//             }
//           }
//         }

//         if (showElement) {
//           $(this).removeClass("hide");
//         } else {
//           $(this).addClass("hide");
//         }
//       } else {
//         // show for all
//         $(this).removeClass("hide");
//       }
//     }
//   });

//   // console.log($('[data-show-for-stores]:not(.hide), [data-show-for-category]:not(.hide)').length);

//   // Show default menu items if location is chosen and is not attached to olo menu data.
//   if (
//     $(
//       ".menu-grid [data-show-for-stores]:not(.hide), .menu-grid [data-show-for-category]:not(.hide)"
//     ).length == 0 &&
//     localStorage.getItem("ecw_visitor_nearest_location_id") 
//   ) {
//     $('[data-show-for-stores]').each(function () {
//       if ($(this).attr('data-show-for-stores').includes('yes')) {
//         $(this).removeClass('hide');
//       } else {
//         $(this).addClass('hide');
//       }
//     });
//   }

//   // Exception for customer alerts
//   // if($('.alert-banner[data-show-for-category]:not(.hide)').length) {
//   //   $('.alert-banner[data-show-for-all]').addClass('hide');
//   // }

//   // Hide elements that must be hidden for stores
//   $("[data-hide-for-stores]").each(function () {
//     var hidestores = $(this).attr("data-hide-for-stores");
//     if (hidestores.length !== 0) {
//       if (hidestores.includes(currentStoreNumber + ",")) {
//         $(this).addClass("hide");
//       } else {
//         $(this).removeClass("hide");
//       }
//     } else {
//       $(this).removeClass("hide");
//     }
//   });

//   // Hide elements related to store category
//   $("[data-hide-for-category]").each(function () {
//     if (currentLocGroups) {
//       var hidecats = $(this).attr("data-hide-for-category").split(",");
//       if (hidecats.length !== 0) {
//         var hideElement = false;

//         // console.log(currentLocGroups, hidecats);

//         if (currentLocGroups && hidecats.length) {
//           for (var s = 0; s < hidecats.length; s++) {
//             for (var ss = 0; ss < currentLocGroups.length; ss++) {
//               if (hidecats[s] == currentLocGroups[ss]) {
//                 hideElement = true;
//                 break;
//               }
//             }
//           }
//         }

//         // console.log(hideElement);

//         if (hideElement) {
//           $(this).addClass("hide");
//         } else {
//           $(this).removeClass("hide");
//         }
//       } else {
//         $(this).addClass("hide");
//       }
//     }
//   });

//   // console.log(currentLocGroups.length);

//   if (currentLocGroups == 0) {
//     $("[data-show-for-no-location]").each(function () {
//       $(this).removeClass("hide");
//     });
//   }

//   if ($('.menu-list-container').find('.food-item.hide').length >= $('.menu-list-container').find('.food-item').length) {
//     $('.category-empty-copy').removeClass('hide');
//   }
// } // showFoodMenu
 